import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
export type Option = { name: string; id: number | string };
export interface OptionItem {
  name: string;
  id: string | number;
}
@Component({
  selector: 'stc-apps-multi-select-dropdown',
  standalone: false,
  templateUrl: './multi-select-dropdown.component.html',
  styleUrl: './multi-select-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
      multi: true,
    },
  ],
})
export class MultiSelectDropdownComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() type = '';
  isStatusDropdownShown = false;
  @Input() label = '';
  @Input() options: OptionItem[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();
  isAllChecked = false;
  selectedValues: string[] = [];
  private lastValidSelection: string[] = [];
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.isAllChecked = this.selectedValues.length === this.options.length;
    }
  }

  writeValue(value: string[]): void {
    if (value) {
      this.selectedValues = value.map((v) => v) ?? [];
      this.lastValidSelection = [...this.selectedValues];
      this.isAllChecked = this.isAllSelected();
      this.isStatusDropdownShown = true;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  private onChange: any = () => {};
  private onTouched: any = () => {};

  // ===== Functions =====
  onMultiSelectChange(event: any) {
    if (event.value.length === 0) {
      this.selectedValues = [event.itemValue.name];
      this.emitChange();
      return;
    }
    const newValues = event.value as string[];

    if (this.selectedValues.length === 1 && newValues.length === 0) {
      return;
    }
    this.selectedValues = newValues;
    this.isAllChecked = this.isAllSelected();
    this.emitChange();
  }

  toggleAll() {
    const allSelected = this.isAllSelected();
    if (allSelected) {
      this.selectedValues = this.options.length ? [this.options[0].name] : [];
    } else {
      this.selectedValues = this.options.map((o) => o.name);
    }
    this.isAllChecked = this.isAllSelected();
    this.emitChange();
  }
  ngOnInit() {
    this.isAllChecked = this.isAllSelected();
  }

  isAllSelected(): boolean {
    return this.selectedValues.length === this.options.length;
  }

  private emitChange() {
    this.onChange(this.selectedValues);
    this.selectionChange.emit([...this.selectedValues]);
  }

  showPanel() {
    this.isStatusDropdownShown = true;
  }
  hidePanel() {
    // const value = this.filtersForm.get('status')?.value;
    const value = this.selectedValues;
    this.isStatusDropdownShown = value && value.length > 0;
  }
}
